import { CaseFormModel } from "./case-form.model";

export class CreateCaseRequestModel extends CaseFormModel {

    constructor(values?: Partial<CreateCaseRequestModel>) {
        super(values);
        Object.assign(this, values);
    }

    public static parseValues(json: any) {
        if(!json) {
            return new CreateCaseRequestModel();
        }
        
        let caseFormModel = CaseFormModel.parseValues(json);
        const responseDetails = {
            // Add any custom fields to define here.
        };

        Object.assign(responseDetails, caseFormModel);
        return new CreateCaseRequestModel(responseDetails);
    }
}
